import { render, staticRenderFns } from "./AddUserToUATForm.vue?vue&type=template&id=1b6885a0&"
import script from "./AddUserToUATForm.vue?vue&type=script&lang=js&"
export * from "./AddUserToUATForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports